import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Preloader = () => {
  const [loading, setLoading] = useState(true);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCounter((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => setLoading(false), 500);
          return 100;
        }
        return prev + 1;
      });
    }, 20);

    return () => clearInterval(timer);
  }, []);

  return (
    <AnimatePresence>
      {loading && (
        <motion.div 
          initial={{ opacity: 1 }}
          exit={{ y: '-100%', transition: { duration: 0.8, ease: [0.76, 0, 0.24, 1] } }}
          className="fixed inset-0 z-[100] bg-navy-900 flex flex-col items-center justify-center"
        >
          <div className="relative overflow-hidden mb-4">
            <motion.div
              initial={{ y: 100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <img 
                src="https://media-manager-c.questera.ai/greta-media/d334477e75b4fabb65d5be5423d2041faad258e6d76e6691f8155cb326e304c728474a3a46f4e57b3b2d456fd1aa0681/images/aW1hZ2UvcG5n/78bb09dd5eee04f99536674bb2e1fd61.png" 
                alt="Page1News Logo" 
                className="h-16 md:h-24 w-auto object-contain"
              />
            </motion.div>
          </div>

          <div className="w-64 h-[1px] bg-white/10 relative overflow-hidden mt-4">
            <motion.div 
              className="absolute top-0 left-0 h-full bg-gold-500"
              style={{ width: `${counter}%` }}
            />
          </div>

          <motion.span 
            className="text-gold-500 font-mono text-sm mt-4 tracking-widest"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {counter}%
          </motion.span>

          <div className="absolute bottom-10 text-white/30 text-xs uppercase tracking-[0.4em]">
            Where Vision Meets Voice
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;